module.exports = __webpack_public_path__ + "static/media/repeat-1.75fa7443.svg";